module.exports = __webpack_public_path__ + "Tinebase/js/ace-ext-elastic_tabstops_lite-FAT.js";